import { SettingOutlined, UserOutlined } from '@ant-design/icons';
import { Col, Layout, Row, Typography } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Bucket from '../Bucket/bucket';
import { SettingsMenu, UserProfileMenu } from '../Settings';
const { Header } = Layout;
const { Link } = Typography;

import './styles.scss';

const TopHeader = ({ bucket, setIsLoading }) => {
	const { reRedactionStatus } = useSelector((store) => store.storeProps);

	return (
		<Header className='header'>
			<Row align='middle'>
				<Col span={6}>
					<div className='left-block-wrapper'>
						<Link href='/dashboard' target={reRedactionStatus ? '_blank' : '_self'}>
							<img src='./fortress-logo-login.svg' className='logo-dashboard' alt='FIQ' />
						</Link>
						<span>{'Privacy Enhanced Gateway'}</span>
					</div>
				</Col>

				<Col span={18}>
					<div className='rightBlock'>
						{bucket && (
							<div className='bucketWrapper'>
								<Bucket setIsLoading={setIsLoading} />
							</div>
						)}
						<div className='logout-wrapper'>
							<SettingOutlined className='settings-icon' style={{ fontSize: '18px' }} />
							<SettingsMenu />
						</div>

						<div
							className={`logout-wrapper ${reRedactionStatus ? 'disableProfile' : ''}`}
							title={reRedactionStatus ? 'Re-redaction is in progress' : ''}
						>
							<UserOutlined className='user-icon' style={{ fontSize: '18px' }} />
							<UserProfileMenu setIsLoading={setIsLoading} />
						</div>
					</div>
				</Col>
			</Row>
		</Header>
	);
};

TopHeader.propTypes = {
	setIsLoading: PropTypes.func,
	bucket: PropTypes.bool,
};

export default TopHeader;
